<template>
  <div class="home">
    <Hero />
    <Steps />
    <Prizes />
    <Voting />
    <Winners />
    <Faq :items="faqItems" />
    <Cup />
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/AppHero.vue";
import Steps from "@/components/AppSteps.vue";
import Prizes from "@/components/AppPrizes.vue";
import Faq from "@/components/AppFaq.vue";
import Winners from "../components/AppWinners.vue";
import Voting from "../components/AppVoting.vue";
import Cup from "../components/AppCup.vue";

export default {
  name: "Home",
  components: {
    Hero,
    Steps,
    Prizes,
    Faq,
    Winners,
    Voting,
    Cup
  },
  data: function () {
    return {
      publicPath: process.env.BASE_URL,
      sectionObserver: null,
      faqItems: [
        {
          title: "Каковы сроки проведения Акции?",
          text: "1. Общий период проведения Акции: с&nbsp;&laquo;01&raquo; декабря 2022&nbsp;г.&nbsp;по&nbsp;&laquo;31&raquo; марта 2023&nbsp;г. включительно.<br>2. Регистрация на&nbsp;Сайте и&nbsp;направление конкурсных работ на&nbsp;участие с&nbsp;&laquo;01&raquo; декабря 2022&nbsp;г.&nbsp;по&nbsp;&laquo;15&raquo; февраля 2023&nbsp;г.<br>3. Определение победителей с&nbsp;&laquo;15&raquo; января 2023&nbsp;г.&nbsp;по&nbsp;&laquo;28&raquo; февраля 2023&nbsp;г.<br>4. Период выдачи призов победителям с&nbsp;&laquo;16&raquo; января 2023&nbsp;г.&nbsp;по&nbsp;&laquo;31&raquo; марта 2023&nbsp;г.",
          isActive: false,
        },
        {
          title: "Кто может принять участие в Акции?",
          text: "Участниками Акции могут быть граждане&nbsp;РФ, достигшие 18&nbsp;летнего возраста и&nbsp;постоянно проживающие на&nbsp;территории Российской Федерации.",
          isActive: false,
        },
        {
          title: "Как принять участие в Акции?",
          text: "1. В&nbsp;период проведения Акции зарегистрироваться на&nbsp;сайте <a href='www.poetti.ru/master' target='_blank'>www.poetti.ru/master</a> подтвердив согласие с&nbsp;Пользовательским соглашением Сайта и&nbsp;настоящими Правилами, для возможности последующей авторизации на&nbsp;Сайте.<br>2. Загрузить фото с&nbsp;пачкой кофе или чашкой Poetti на&nbsp;Сайте. <br>3. Указать в&nbsp;форме на&nbsp;Сайте мастер какого&nbsp;Вы дела.<br>4. Разместить конкурсную работу на&nbsp;сайте Акции",
          isActive: false,
        },
        {
          title: "Какие продукты участвуют в Акции?",
          text: "Вся линейка продукции Poetti",
          isActive: false,
        },
        {
          title: "Где я могу приобрести данный продукт?",
          text: "Продукт для участия в&nbsp;Акции можно купить на&nbsp;территории Российской Федерации в&nbsp;любой розничной точек продаж.",
          isActive: false,
        },
        {
          title: "Сколько конкурсных работ я&nbsp;могу загрузить?",
          text: "Участник может представить не&nbsp;более&nbsp;3 (Трех) Конкурсных работ, каждая из&nbsp;которых будет претендовать на&nbsp;победу в&nbsp;розыгрыше Специального и&nbsp;Главного призов.",
          isActive: false,
        },
        {
          title: "Какие требования к фото?",
          text: "&bull; Фото должно быть горизонтального или вертикального формата с&nbsp;условием, что Участник с&nbsp;продуктом помещается в&nbsp;соотношение сторон 1&times;1 без отсечения важных элементов (лица и&nbsp;эмоции Участника, продукта в&nbsp;кадре).<br>&bull; Обязательный элемент в&nbsp;кадре&nbsp;&mdash; Участник с&nbsp;брендированной чашкой Poetti&nbsp;/ пачкой кофе Poetti.<br>&bull; Фото должно быть четким и&nbsp;понятным, без замыленности, не&nbsp;допускается присутствие в&nbsp;кадре других кофейных брендов, кроме Poetti.<br>&bull; Разрешение фото не&nbsp;ниже 3000&times;2250 для горизонтального фото и&nbsp;2250&times;3000 для вертикального, при 72DPI.<br>&bull; Размер фото не&nbsp;больше 5мб.",
          isActive: false,
        },
        {
          title: "Какие призы я&nbsp;могу получить за&nbsp;участие в&nbsp;Акции?",
          text: "1. Приз за&nbsp;репост:<br>&mdash;&nbsp;Купон на&nbsp;пачку кофе Poetti на&nbsp;маркетплейсе &laquo;Ozon&raquo;. <br>Общее количество Призов за&nbsp;репост&nbsp;&mdash; 300&nbsp;штук.<br><br>2. Специальный приз:<br>&mdash;&nbsp;Годовой запас кофе Poetti (12&nbsp;пачек зернового кофе Poetti Leggenda по&nbsp;1&nbsp;кг) номинальной стоимостью 7&nbsp;920&nbsp;рублей.<br>Общее количество призов&nbsp;&mdash; 10&nbsp;штук.<br><br>3. Дополнительные призы (призы в&nbsp;розыгрыше):<br>&mdash;&nbsp;Кофемашина DeLonghi номинальной стоимостью 53&nbsp;999&nbsp;рублей.<br>Общее количество призов&nbsp;&mdash; 1&nbsp;штука.<br><br>4. Главный приз:<br>&mdash;&nbsp;Трансляция Конкурсной работы на&nbsp;биллборде, а&nbsp;также Годовой запас кофе Poetti (12&nbsp;пачек зернового кофе Poetti Leggenda по&nbsp;1&nbsp;кг) стоимостью 7&nbsp;920&nbsp;рублей.<br>Общее количество Главных призов&nbsp;&mdash; 10&nbsp;штук.",
          isActive: false,
        },
        {
          title: "Как я могу получить приз за репост?",
          text: "Приз за&nbsp;репост Конкурсной работы в&nbsp;социальной сети &laquo;ВКонтакте&raquo; Участник получает в&nbsp;электронном виде на&nbsp;электронную почту, указанную при регистрации. <br>Один Участник может получить не&nbsp;более&nbsp;1 (одного) Приза за&nbsp;репост.",
          isActive: false,
        },
        {
          title: "Что нужно сделать, чтобы выиграть Специальный приз?",
          text: "Специальные призы определяются среди Участников, чьи Конкурсные работы заняли первые 10&nbsp;мест по&nbsp;итогам открытого голосования Участниками Акции на&nbsp;Сайте.<br>Один Участник может получить не&nbsp;более&nbsp;1 (одного) Приза",
          isActive: false,
        },
        {
          title: "Как можно выиграть Дополнительный приз Акции?",
          text: "Дополнительный приз определяется в&nbsp;конце Акции с&nbsp;&laquo;16&raquo; февраля 2023&nbsp;г.&nbsp;по&nbsp;&laquo;28&raquo; февраля 2023&nbsp;г. среди всех Участников, по&nbsp;математической формуле указанной п.6.3. Правил Акции",
          isActive: false,
        },
        {
          title: "Как можно выиграть Главный приз Акции?",
          text: "Обладатели Главных призов определяются творческой комиссии во&nbsp;главе с&nbsp;Андреем Бурковским в&nbsp;составе: Oрганизатор, Заказчик Акции и&nbsp;Андрей Бурковский.",
          isActive: false,
        },
        {
          title: "Надо ли платить налоги с приза?",
          text: "Призы, стоимость которых превышает 4&nbsp;000&nbsp;рублей, облагаются налогом в&nbsp;размере 35%. Налог на&nbsp;приз оплачивает Оператор Акции, который, как налоговый Агент, на&nbsp;основании поручения от&nbsp;Победителя удержит в&nbsp;соответствие с&nbsp;требованиями законодательства РФ&nbsp;НДФЛ по&nbsp;ставке&nbsp;35%",
          isActive: false,
        },
        {
          title: "Что делать, если возникли вопросы, ответов на&nbsp;которые нет в&nbsp;этом F.A.Q.?",
          text: "В&nbsp;случае, если ты&nbsp;Вы не&nbsp;нашели ответ на&nbsp;свой вопрос, обратись в&nbsp;службу технической поддержки после старта Акции, заполнив форму обратной связи. Ответ поступит в&nbsp;течение 24&nbsp;часов. Если запрос приходится на&nbsp;выходной день, ответ поступит в&nbsp;ближайший рабочий день.",
          isActive: false,
        },
      ],
    };
  },
  mounted() {

    // this.observeSections();
    window.addEventListener("scroll", function () {
      if (window.scrollY > 100) {
        document.querySelector(".header").classList.add("_modified");
      } else {
        document.querySelector(".header").classList.remove("_modified");
      }
    });
    if (window.innerWidth >= 1024) {
      const sections = document.querySelectorAll(".section");
      const links = document.querySelectorAll("[data-menuanchor]");
      document.addEventListener("scroll", (e) => {
        sections.forEach((ha) => {
          const rect = ha.getBoundingClientRect();
          if ((rect.top > 0 && rect.top < 100) || (rect.bottom > 0 && rect.bottom < 1000)) {
            const location = window.location.toString().split("#")[0];
            history.replaceState(null, null, location + "#" + ha.id );
            
            links.forEach((element) => {
              element.classList.remove("active");
            });
            document
              .querySelector(`[data-menuanchor='${ha.id}']`)
              .classList.add("active");
          }
          // console.log(rect);
        });
        if (window.scrollY === 0 && this.$route.name === 'Home') {
          const location = window.location.toString().split("#")[0];
          links.forEach((element) => {
            element.classList.remove("active");
          });
          history.replaceState(null, null, location + "#home");
          document
            .querySelector(`[data-menuanchor='home']`)
            .classList.add("active");
        }
      });
    }
    this.$parent.showFooter = false;
    const params = this.$route.query;
    if (params.email === "0") {
      let socId = params.identity_vk || params.identity_ok || "";

      console.log(socId);

      if (socId.length < 1) {
        this.$modal.show("common_error", {
          title: "Что-то пошло не так!",
        });
        this.$router.push("/");
      } else {
        this.$store.commit("SIGNUP_SOC_ID", socId);
        this.$modal.show("soc_signup");
        this.$router.push({
          name: "Home"
        });
      }
    } else if (params.first === "1") {
      this.$store.commit("SET_TOKEN", params.auth_key);
      this.$store.dispatch("GetProfile").then((r) => {
        this.$modal.show("soc_signup-finish", {
          userName: r.data.profile.name,
        });
        this.$router.push({
          name: "Home"
        });
      });
    } else if (params.result === "1") {
      this.$store.commit("SET_TOKEN", params.auth_key);

      this.$store.dispatch("GetProfile").then(() => {
        this.$router.push("/");
      });
    }
  },
  methods: {
    observeSections() {
      try {
        this.sectionObserver.disconnect();
      } catch (error) {
        console.log(error);
      }

      const options = {
        rootMargin: "0px 0px",
        threshold: 0,
      };
      this.sectionObserver = new IntersectionObserver(
        this.sectionObserverHandler,
        options
      );

      // Observe each section
      const sections = document.querySelectorAll(".section");
      sections.forEach((section) => {
        this.sectionObserver.observe(section);
      });
    },
    sectionObserverHandler(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          // Push sectionId to router here
          this.$router.replace({
            name: this.$route.name,
            hash: `#${sectionId}`,
          });
          console.log(sectionId);
          // this.$route.hash = `#${sectionId}`;

          console.log(this.$route.hash);
        }
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  created() {},
};
</script>
<style lang="scss">
p + .tg {
  margin-top: rem(20px);
}
.tg {
  border-collapse: collapse;
  border-color: #ccc;
  border-spacing: 0;
  &-wrapper {
    padding-bottom: rem(10px);
    margin-bottom: rem(20px);
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: rem(10px);
      height: rem(5px);
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: $green;
      border-radius: 10px;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: $green_dark;
      border-radius: 10px;
      transition: all 0.3s ease-in-out;
    }
  }
  & + p {
    margin-top: rem(20px);
  }
}
.tg td {
  background-color: #fff;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  font-size: rem(16px);
  font-weight: 400;
  overflow: hidden;
  padding: rem(8px) rem(10px);
  word-break: normal;
}
.tg th {
  background-color: #f0f0f0;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  text-align: center;
  font-size: rem(16px);
  overflow: hidden;
  padding: rem(10px) rem(10px);
  word-break: normal;
}
.tg .tg-buh4 {
  background-color: #f9f9f9;
  vertical-align: top;
}
.tg .tg-0pky {
  vertical-align: top;
}
.tg .tg-0lax {
  vertical-align: top;
}
</style>
